<template>
  <div class="inventory-mobile">
    <div class="mobile-form-header">
      <div class="header-left">
        <b-button v-if="onClose" class="close-modal-btn" @click="onClose">
          <b-icon-x scale="1.5"></b-icon-x>
        </b-button>
        <h2 class="form-title">
          <b-icon-box-seam></b-icon-box-seam>
          Movimentações de agrotóxicos
        </h2>
      </div>
      <b-button v-if="showOpenRecipeButton" class="receipt-btn" size="sm">
        <b-icon-file-text class="mr-1"></b-icon-file-text>
        Abrir Receita
      </b-button>
    </div>

    <div class="mobile-form">
      <div class="form-section">
        <div class="section-header">
          <b-icon-box-seam></b-icon-box-seam>
          <span>Informações do agrotóxico</span>
        </div>

        <div class="form-fields">
          <div class="field-wrapper">
            <InputProducts
              key="agro"
              label="Agrotóxicos"
              typeFilter="pesticides"
              :isEdit="dataInventory.id || dataInventory.idAgrotoxico"
              :dataInput.sync="dataInventory.idAgrotoxico"
              :onSearch="fillPesticidesComboBoxWithPaginate"
              :clearSelected="toggleClearSelect"
              :searchFields="['nomeComum']"
              :isInvalidInput="invalidFields?.idAgrotoxico || ''"
              @selectItem="getAllEmbalagensAgrotoxico"
              @clearInvalidInput="clearInvalidFields('idAgrotoxico')"
            />
          </div>

          <div class="field-wrapper">
            <InputSelect
              label="Fornecedor"
              valueField="id"
              textField="razaoSocial"
              :items="allSupplier"
              :dataSelect.sync="dataInventory.idFornecedor"
              :isInvalidInput="invalidFields?.idFornecedor || ''"
              :openCreateModal="() => openModals('modalCreateSupplier')"
              @clearInvalidInput="clearInvalidFields('idFornecedor')"
              ref="idFornecedor"
            />
          </div>

          <div class="field-wrapper">
            <InputSelect
              label="Embalagens"
              valueField="descricao"
              textField="descricao"
              :items="listEmbalagens"
              :dataSelect.sync="dataInventory.embalagem"
              :dataInput="dataInventory.embalagem"
              :enableIconCreate="false"
              :isInvalidInput="invalidFields?.embalagem || ''"
              @clearInvalidInput="clearInvalidFields('embalagem')"
              @selectedIten="handleAssingEmb"
              ref="embalagem"
            />
          </div>

          <div class="field-row">
            <div class="field-wrapper half">
              <!-- <Input
                label="Quantidade"
                type="number"
                labelFixed
                :dataInput.sync="dataInventory.quantidade"
                :isInvalidInput="invalidFields?.quantidade || ''"
                @clearInvalidInput="clearInvalidFields('quantidade')"
                ref="quantidade"
              /> -->

              <InputQuant
                style="width: 100%"
                label="Quantidade"
                type="text"
                labelFixed
                :dataInput.sync="dataInventory.quantidade"
                :isInvalidInput="invalidFields?.quantidade || ''"
                @clearInvalidInput="clearInvalidFields('quantidade')"
                ref="quantidade"
              />
            </div>

            <div class="field-wrapper half">
              <Input
                label="Lote"
                labelFixed
                :dataInput.sync="dataInventory.lote"
                :isInvalidInput="invalidFields?.lote || ''"
                @clearInvalidInput="clearInvalidFields('lote')"
                ref="lote"
              />
            </div>
          </div>

          <div class="field-wrapper">
            <label class="textarea-label">Observações</label>
            <textarea
              rows="3"
              class="textarea-input"
              v-model="dataInventory.observacao"
              placeholder="Digite suas observações..."
            />
          </div>
        </div>
      </div>

      <div class="form-section">
        <div class="section-header">
          <b-icon-person-lines-fill></b-icon-person-lines-fill>
          <span>Informações Gerais</span>
        </div>

        <div class="form-fields">
          <div class="field-wrapper">
            <InputSelect
              label="Responsável Técnico"
              valueField="id"
              textField="nome"
              :items="responsibles"
              :dataSelect.sync="dataInventory.idResponsavel"
              :dataInput="dataInventory.idResponsavel"
              :isInvalidInput="invalidFields?.idResponsavel || ''"
              :openCreateModal="() => openModals('modalResponsible')"
              @clearInvalidInput="clearInvalidFields('idResponsavel')"
              ref="idResponsavel"
            />
          </div>

          <div class="field-wrapper">
            <InputSelect
              label="Tipo de Movimentação"
              valueField="value"
              textField="text"
              :items="movimentTypes"
              :dataSelect.sync="dataInventory.tipo"
              :dataInput="dataInventory.tipo"
              :enableIconCreate="false"
              :isInvalidInput="invalidFields?.tipo || ''"
              @clearInvalidInput="clearInvalidFields('tipo')"
              @selectedIten="setInventoryDefaults($event, true)"
              ref="tipo"
            />
          </div>

          <div class="field-row">
            <div class="field-wrapper half">
              <Input
                label="Data"
                type="date"
                labelFixed
                :dataInput.sync="dataInventory.data"
                :isInvalidInput="invalidFields?.data || ''"
                @clearInvalidInput="clearInvalidFields('data')"
                ref="data"
              />
            </div>

            <div class="field-wrapper half">
              <Input
                label="Data Vencimento"
                type="date"
                labelFixed
                :dataInput.sync="dataInventory.dataVencimento"
                ref="dataVencimento"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="form-section">
        <div class="section-header">
          <b-icon-receipt-cutoff></b-icon-receipt-cutoff>
          <span>Informações fiscais</span>
        </div>

        <div class="form-fields">
          <div class="field-wrapper">
            <Input
              label="Data NF-e"
              type="date"
              labelFixed
              :dataInput.sync="dataInventory.dataNfe"
              :isInvalidInput="invalidFields?.dataNfe || ''"
              @clearInvalidInput="clearInvalidFields('dataNfe')"
              ref="dataNfe"
            />
          </div>

          <div class="field-row">
            <div class="field-wrapper half">
              <Input
                label="Nº NF-e"
                type="number"
                labelFixed
                :dataInput.sync="dataInventory.numeroNfe"
                :isInvalidInput="invalidFields?.numeroNfe || ''"
                @clearInvalidInput="clearInvalidFields('numeroNfe')"
                ref="numeroNfe"
              />
            </div>

            <div class="field-wrapper half">
              <Input
                label="Serie"
                type="number"
                labelFixed
                :dataInput.sync="dataInventory.serieNfe"
                :isInvalidInput="invalidFields?.serieNfe || ''"
                @clearInvalidInput="clearInvalidFields('serieNfe')"
                ref="serieNfe"
              />
            </div>
          </div>

          <div class="field-wrapper">
            <InputSelect
              label="Destino"
              valueField="value"
              textField="text"
              :items="tipoOperacao"
              :dataSelect.sync="dataInventory.destinoProduto"
              :dataInput="dataInventory.destinoProduto"
              :isInvalidInput="invalidFields?.destinoProduto || ''"
              :enableIconCreate="false"
              @clearInvalidInput="clearInvalidFields('destinoProduto')"
              ref="destinoProduto"
            />
          </div>

          <div class="field-wrapper">
            <InputSelect
              label="Natureza de Operação"
              valueField="value"
              textField="text"
              :items="natureOps"
              :dataSelect.sync="dataInventory.naturezaOperacao"
              :dataInput="dataInventory.naturezaOperacao"
              :isInvalidInput="invalidFields?.naturezaOperacao || ''"
              :enableIconCreate="false"
              @clearInvalidInput="clearInvalidFields('naturezaOperacao')"
              ref="naturezaOperacao"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="action-buttons-fixed">
      <b-button class="action-btn secondary" @click="clearInputs" size="lg">
        <b-icon-arrow-counterclockwise
          class="mr-2"
        ></b-icon-arrow-counterclockwise>
        Novo
      </b-button>
      <b-button
        class="action-btn primary"
        :disabled="loading"
        @click="handleSaveOrUpdate"
        size="lg"
      >
        <b-spinner v-if="loading" small class="mr-2"></b-spinner>
        <b-icon-check-circle v-else class="mr-2"></b-icon-check-circle>
        Salvar
      </b-button>
    </div>

    <ModalCreateSupplier @getAllNewSupplier="getAllSuppliers" />
    <ModalResponsible @getAllResponsibles="getAllResponsibles" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { DateTime } from "luxon";

import ModalCreateSupplier from "../Modals/ModalCreateSupplier.vue";
import ModalResponsible from "../Modals/ModalResponsible.vue";
import InputProducts from "../../components/UI/CustomInputs/InputProducts.vue";
import InputSelect from "../../components/UI/CustomInputs/InputSelect.vue";
import Input from "../../components/UI/CustomInputs/Input.vue";
import InputQuant from "../../components/UI/CustomInputs/InputQuant.vue";

import ServiceSupplier from "../../services/serviceSupplier";
import ServiceResponsible from "../../services/serviceResponsible";
import ServiceCompendio from "../../services/serviceCompendio";
import ServiceMovimentPesticides from "../../services/serviceMovimentPesticides";

import { removeReference } from "../../utils/removeReference";
import { HandleErrors } from "../../utils/handleErrors";
import { ValidateMovimentPerticides } from "../../validators/movimentPerticides";
import {
  INITIAL_STATE_MOVIMENT_PESTICIDES,
  INVALID_FIELDS_MOVIMENT_PESTICIDES,
} from "../../initialStates/movimentPesticides";

export default {
  components: {
    InputSelect,
    InputProducts,
    Input,
    InputQuant,
    ModalCreateSupplier,
    ModalResponsible,
  },
  props: {
    dataEditPurchase: {
      type: Object,
    },
    onClose: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      getAllProducts: null,
      allSupplier: [],
      responsibles: [],
      dataInventory: removeReference(INITIAL_STATE_MOVIMENT_PESTICIDES),
      invalidFields: removeReference(INVALID_FIELDS_MOVIMENT_PESTICIDES),
      natureOps: [
        { value: "Entrada", text: "Entrada" },
        { value: "Saida", text: "Saída" },
        { value: "", text: "Selecione..." },
      ],
      movimentTypes: [
        { value: "", text: "Selecione..." },
        { text: "Compra", value: "Compra" },
        { text: "Entrada", value: "Entrada" },
        { text: "Inventario Entrada", value: "Inventario Entrada" },
        { text: "Transferência Entrada", value: "Transferência Entrada" },
        { text: "Devolução Entrada", value: "Devolução Entrada" },
        { text: "Devolução Saída", value: "Devolução" },
        { text: "Inventario Saida", value: "Inventario Saida" },
        { text: "Transferência Saida", value: "Transferência Saida" },
        { text: "Venda", value: "Venda" },
      ],
      tipoOperacao: [
        { text: "Dentro do estado", value: "Dentro Estado" },
        { text: "Fora do estado", value: "Fora Estado" },
      ],
      listEmbalagens: [],
      toggleClearSelect: false,
    };
  },
  methods: {
    async handleSaveOrUpdate() {
      this.setInventoryDefaults();

      if (!this.validate()) {
        return;
      }

      this.dataInventory.id ? await this.update() : await this.save();
    },

    setInventoryDefaults(
      type = this.dataInventory.tipo,
      updateNature = false
    ) {
      const natureByInventoryType = {
        "Inventario Entrada": "Entrada",
        "Inventario Saida": "Saida",
      };
      const natureOperation = natureByInventoryType[type];

      if (!natureOperation) return;

      if (!this.dataInventory.dataNfe) {
        this.dataInventory.dataNfe = DateTime.local().toFormat("yyyy-MM-dd");
      }

      if (!this.dataInventory.numeroNfe) this.dataInventory.numeroNfe = "1";
      if (!this.dataInventory.serieNfe) this.dataInventory.serieNfe = "1";

      if (updateNature || !this.dataInventory.naturezaOperacao) {
        this.dataInventory.naturezaOperacao = natureOperation;
      }

      this.$nextTick(this.syncInventoryDefaultRefs);
    },

    syncInventoryDefaultRefs() {
      ["dataNfe", "numeroNfe", "serieNfe"].forEach((key) => {
        if (this.$refs[key]) {
          this.$refs[key].valueInput = this.dataInventory[key];
        }
      });

      if (this.$refs.naturezaOperacao) {
        this.$refs.naturezaOperacao.valueItems =
          this.dataInventory.naturezaOperacao;
      }
    },

    async save() {
      try {
        this.loading = true;
        const result = await ServiceMovimentPesticides.save(this.dataInventory);

        this.dataInventory.id = result.id;

        this.$toast.open({
          message: "Nova movimentação registrada!",
        });
      } catch (error) {
        const message = error?.response?.data?.message;

        if (message && message.includes("NOT_ALLOWED"))
          return this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });

        const typeError = HandleErrors(error?.response?.data?.message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        } else
          return this.$toast.open({
            message: `${error.response.data.message}`,
            type: "error",
          });
      } finally {
        this.loading = false;
      }
    },

    async update() {
      try {
        this.loading = true;

        await ServiceMovimentPesticides.update(
          this.dataInventory.id,
          this.dataInventory
        );

        this.$toast.open({
          message: "Movimentação Atualizada!",
        });
      } catch (error) {
        const message = error?.response?.data?.message;

        if (message && message.includes("NOT_ALLOWED"))
          return this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });

        const typeError = HandleErrors(error?.response?.data?.message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        } else
          return this.$toast.open({
            message: `${error.response.data.message}`,
            type: "error",
          });
      } finally {
        this.loading = false;
      }
    },

    async fillPesticidesComboBoxWithPaginate(
      id,
      q,
      filterType,
      page,
      typeProduct
    ) {
      try {
        const { data } = await ServiceCompendio.combobox(
          id,
          q,
          filterType,
          page,
          typeProduct
        );

        return data?.map((agro) => {
          return {
            id: +agro.id,
            nome: agro.nomeComum,
            registro: agro.registro,
          };
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os produtos",
          type: "info",
        });

        return;
      }
    },

    async getAllSuppliers() {
      const selectedId = this.dataSearchFromMovimentPesticides.id
        ? this.dataSearchFromMovimentPesticides.idFornecedor
        : undefined;
      this.allSupplier = await ServiceSupplier.fillComobobox(selectedId);
    },

    async getAllResponsibles() {
      this.responsibles = await ServiceResponsible.findAll();
    },

    async getAllEmbalagensAgrotoxico(agrotoxico) {
      this.listEmbalagens =
        await ServiceCompendio.findAllEmbalagensByIdAgrotoxico(agrotoxico.id);
    },

    validate() {
      const isNotValid = ValidateMovimentPerticides(this.dataInventory);
      return this.handleValidateErrors(isNotValid);
    },

    handleAssingEmb(emb) {
      this.dataInventory.embalagem =
        this.listEmbalagens.find((embItem) => embItem.descricao === emb)
          ?.descricao || null;
    },

    handleValidateErrors(errors) {
      if (errors && errors.length) {
        errors.forEach((erro) => {
          this.invalidFields[erro.keyError] = "isInvalidInput";
        });

        this.$toast.open({
          message: "Existem campos obrigatórios!",
          type: "info",
        });

        return false;
      }

      return true;
    },

    clearInvalidFields(key) {
      if (this.invalidFields[key]) this.invalidFields[key] = "";
    },

    clearInputs() {
      this.dataInventory = removeReference(INITIAL_STATE_MOVIMENT_PESTICIDES);
      this.invalidFields = removeReference(INVALID_FIELDS_MOVIMENT_PESTICIDES);

      this.toggleClearSelect = !this.toggleClearSelect;
      this.clearRefs();
    },

    clearRefs() {
      Object.keys(INITIAL_STATE_MOVIMENT_PESTICIDES).forEach((key) => {
        if (this.$refs[key] && this.$refs[key]?.valueInput)
          this.$refs[key].valueInput = "";
        else if (this.$refs[key] && this.$refs[key]?.valueItems)
          this.$refs[key].valueItems =
            key === "destinoProduto" ? "Dentro Estado" : "";
      });
    },

    handleAssingToEdit() {
      if (this.dataSearchFromMovimentPesticides.id) {
        Object.assign(
          this.dataInventory,
          this.dataSearchFromMovimentPesticides
        );

        Object.keys(INITIAL_STATE_MOVIMENT_PESTICIDES).forEach((key) => {
          const ref = this.$refs[key];

          if (ref && "valueInput" in ref)
            this.$refs[key].valueInput = this.dataInventory[key];
          else if (ref && "valueItems" in ref)
            this.$refs[key].valueItems = this.dataInventory[key];
        });
      }
    },

    openModals(idModal) {
      this.$bvModal.show(idModal);
    },
  },
  computed: {
    ...mapState(["dataSearchFromMovimentPesticides"]),
    showOpenRecipeButton() {
      return Boolean(this.dataInventory.id);
    },
  },
  created() {
    this.handleAssingToEdit();
  },
  mounted() {
    this.getAllSuppliers();
    this.getAllResponsibles();
  },
};
</script>

<style scoped>
.inventory-mobile {
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  padding: 0;
  font-family: "Poppins-Regular", sans-serif;
  background: #f8f9fa;
  min-height: 100vh;
  padding-bottom: 100px;
}

.mobile-form-header {
  background: white;
  padding: 16px;
  border-bottom: 2px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  position: sticky;
  top: 0;
  z-index: 999999;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.close-modal-btn {
  width: 40px;
  height: 40px;
  min-height: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border: 2px solid #dee2e6;
  color: #495057;
  border-radius: 8px;
  flex-shrink: 0;
  transition: all 0.2s;
}

.close-modal-btn:hover,
.close-modal-btn:focus {
  background: #dc3545;
  border-color: #dc3545;
  color: white;
  transform: scale(1.05);
}

.close-modal-btn:active {
  transform: scale(0.95);
}

.form-title {
  font-size: 0.8rem;
  font-weight: 700;
  color: #212529;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  line-height: 1.3;
  min-width: 0;
}

.receipt-btn {
  background: #006458;
  border: none;
  color: white;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 8px 12px;
  border-radius: 6px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 100, 88, 0.2);
}

.receipt-btn:hover,
.receipt-btn:focus {
  background: #00867a;
  box-shadow: 0 4px 8px rgba(0, 100, 88, 0.3);
}

.mobile-form {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-section {
  background: white;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  border: 1px solid #e9ecef;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.95rem;
  font-weight: 700;
  color: #495057;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f1f3f5;
}

.section-header svg {
  color: #006458;
  font-size: 1.1rem;
}

.form-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.field-wrapper {
  width: 100%;
}

.field-row {
  display: flex;
  gap: 12px;
  width: 100%;
}

.field-wrapper.half {
  flex: 1;
  min-width: 0;
}

.textarea-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
  display: block;
}

.textarea-input {
  width: 100%;
  padding: 12px;
  border: 2px solid #dee2e6;
  border-radius: 8px;
  font-size: 16px;
  font-family: "Poppins-Regular", sans-serif;
  resize: vertical;
  min-height: 80px;
  transition: all 0.2s;
  background: white;
}

.textarea-input:focus {
  border-color: #006458;
  box-shadow: 0 0 0 3px rgba(0, 100, 88, 0.1);
  outline: none;
}

.textarea-input::placeholder {
  color: #adb5bd;
}

.action-buttons-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  padding: 12px;
  display: flex;
  gap: 12px;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.1);
  z-index: 200;
}

.action-btn {
  flex: 1;
  padding: 14px 20px;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s;
  border: none;
  min-height: 48px;
}

.action-btn.primary {
  background: #28a745;
  color: white;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.action-btn.primary:hover,
.action-btn.primary:focus {
  background: #218838;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(40, 167, 69, 0.4);
}

.action-btn.primary:active {
  transform: translateY(0);
}

.action-btn.primary:disabled {
  background: #6c757d;
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.action-btn.secondary {
  background: white;
  color: #6c757d;
  border: 2px solid #6c757d;
}

.action-btn.secondary:hover,
.action-btn.secondary:focus {
  background: #6c757d;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(108, 117, 125, 0.3);
}

.action-btn.secondary:active {
  transform: translateY(0);
}

@media screen and (min-width: 375px) {
  .form-title {
    font-size: 1rem;
  }

  .mobile-form {
    padding: 16px;
  }
}

@media screen and (min-width: 425px) {
  .mobile-form-header {
    padding: 20px;
  }

  .form-section {
    padding: 20px;
  }

  .action-buttons-fixed {
    padding: 16px;
  }
}

@media screen and (min-width: 768px) {
  .inventory-mobile {
    max-width: 700px;
    margin: 0 auto;
  }

  .mobile-form {
    padding: 20px;
  }

  .action-buttons-fixed {
    max-width: 700px;
    left: 50%;
    transform: translateX(-50%);
  }
}

@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

button,
input,
select,
textarea {
  min-height: 44px;
}

button:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible {
  outline: 3px solid #006458;
  outline-offset: 2px;
}
</style>
